/** Formatting helpers shared by every view. */

export function formatDuration(totalSeconds) {
  const s = Math.max(0, Number(totalSeconds) || 0);
  const m = Math.floor(s / 60);
  const rest = s - m * 60;
  if (m === 0) return `${rest.toFixed(rest < 10 ? 1 : 0)}s`;
  return `${m}m ${rest.toFixed(0).padStart(2, '0')}s`;
}

export function formatClock(seconds) {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  const m = Math.floor(s / 60);
  return `${String(m).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}

export function formatBytes(bytes) {
  const b = Number(bytes) || 0;
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
  if (b < 1024 * 1024 * 1024) return `${(b / 1024 / 1024).toFixed(1)} MB`;
  return `${(b / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

export function formatDateTime(ts) {
  if (!ts) return '-';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '-';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function relativeTime(ts, now = Date.now()) {
  if (!ts) return 'never';
  const diff = Math.max(0, now - new Date(ts).getTime());
  const min = Math.floor(diff / 60000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min}m ago`;
  const hours = Math.floor(min / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return formatDateTime(ts).slice(0, 10);
}

export function formatUsd(amount) {
  if (!Number.isFinite(amount)) return 'unknown';
  return `$${amount.toFixed(amount < 1 ? 3 : 2)}`;
}

export function truncate(text, max = 120) {
  const s = String(text ?? '');
  return s.length <= max ? s : `${s.slice(0, max - 1)}\u2026`;
}
